/*
 * Restock Date
 *
 *
 **/

custom.restockDate = (() => {
  const restockDateClass = 'js-restock-date';

  let allRestockDatePromises = [];
  let actions = {}; // Events store

  // Subscribe to events
  function on(evt = null, callback = () => {}) {
    if (!evt || !callback || typeof callback !== 'function') return;
    actions[evt] = actions[evt] || [];
    return actions[evt].push(callback);
  }

  // Trigger events
  function trigger(evt = null, payload = {}) {
    if (!evt || !actions[evt]) return;
    return actions[evt].forEach((fn) => fn(payload));
  }

  // Error Handler
  function errorHandler({ responseJSON }) {
    return console.log('Restock Date Error: ', responseJSON);
  }

  /*
   * NOTE: Temporary method just to extract json out of html response
   */
  function extractJson(data = null) {
    const jsonData = JSON.parse(
      $(data)
        .find("[name='test-json']")
        .text()
        .replace(/\s|\r?\n/g, ''),
    );
    return jsonData;
  }

  /**
   * hasOutOfStock
   *
   * returns true/false of OOS product existense
   */
  function hasOutOfStock() {
    return $(`.${restockDateClass}`).length > 0;
  }

  function fallbackRestockDate() {
    const d = new Date();
    let month;
    let year;
    if (d.getMonth() + 7 > 12) {
      month = d.getMonth() - 5;
      year = d.getFullYear() + 1;
    } else {
      month = d.getMonth() + 7;
      year = d.getFullYear();
    }
    const date = `${month}/${d.getDate()}/${year}`;
    return date;
  }

  function dateValid(date = null) {
    const dateValid =
      date === '0' ||
      date === 'TBD' ||
      date === '' ||
      date === null ||
      date == 'ERROR: Invalid Expression'
        ? false
        : true;
    return dateValid;
  }

  /**
   * Date Formetter
   *
   * @param {string} date - ie) 5/5/2018
   */
  function dateFormatter(date = null) {
    if (!dateValid(date)) {
      return $('.template-cart').length > 0
        ? 'No estimated restock date. Items will ship when ready'
        : 'Restock: ETA Pending';
    } else {
      date = dateValid(date) ? date : fallbackRestockDate();
      const arr = date.split('/');
      const month = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
      ];
      return `Restock: ${month[arr[0] - 1]} ${arr[1]}`;
    }
  }
  /**
   * Date Formetter from JS date
   *
   * @param {date} date - Javascript date format
   */
  function getFormattedDateString(date) {
    let year = date.getFullYear();
    let month = (1 + date.getMonth()).toString().padStart(2, '0');
    let day = date.getDate().toString().padStart(2, '0');

    return dateFormatter(month + '/' + day + '/' + year);
  }

  /**
   * First Restock Date
   * Retrieve only first restock date from SPARS response
   *
   * @param {object} ETA object from SPARS
   */
  function getFirstRestockDate(payload = null) {
    if (!payload || payload.eta === false) return 'Restock: ETA Pending';
    return dateFormatter(payload.eta.ETAInfo[0].Message);
  }

  /**
   * Get ETA info from SPARS
   * Made this public since will be used in cart-state
   *
   * @param {string} sku - Product variant sku
   * @param {function} callback - after getting response
   */
  function getETA(sku = null, callback = () => {}) {
    return window.MUAPP.restockDate ? window.MUAPP.restockDate(sku) : false;
  }

  /**
   * Display Restock Date
   * Find out-of-stock in Inventroy Panel and Replace
   *
   * @param {object} data - ETA info coming from SPARS
   * @param {string} sku - Product variant sku
   */
  function returnRestockDate(data = null, sku = null) {
    // const payload = extractJson(data);
    const date = getFirstRestockDate(data);
    const dateUnformatted = data.eta
      ? data.eta.ETAInfo[0].Message
      : 'Restock: ETA Pending';

    // Return date, sku
    trigger('return-date', { date, sku, dateUnformatted });
  }

  /**
   * Handler
   */
  function restockDateHandler(i, el) {
    const sku = $(el).data('sku');
    const getEtaPromise = getETA(sku);

    allRestockDatePromises.push(getEtaPromise);
    if (!getEtaPromise) returnRestockDate('Restock: ETA Pending', sku);
    getEtaPromise.done((data) => returnRestockDate(data, sku));
  }

  /**
   * Initialization of inventory
   */
  function init() {
    if ($(`.${restockDateClass}`).length <= 0) return;
    $restockEls = $(`.${restockDateClass}`);
    allRestockDatePromises = [];
    $.each($restockEls, restockDateHandler);
    $.when.apply($, allRestockDatePromises).done((data) => {
      if (data) window.pubsub.trigger('restockDateFetched');
    });
  }

  return {
    dateValid,
    fallbackRestockDate,
    init,
    on,
    trigger,
    extractJson,
    getETA,
    dateFormatter,
    getFormattedDateString,
    hasOutOfStock,
    getFirstRestockDate,
  };
})();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/restock-date.js